import { Card, CardContent } from '@/components/ui/card';
import { ChevronRight, ClipboardPlus } from 'lucide-react';
import { formatDateToDDMMYYYY } from '../utils/formatDate';
import { FaHourglassHalf } from "react-icons/fa";

interface Props {
  action: () => void;
  date: string;
  labName: string;
  numberOfMarkers: number;
  isReadable?: boolean;
}
export const ReportCard = ({
  isReadable,
  action,
  date,
  labName,
  numberOfMarkers: numberOfDocs,
}: Props) => {
  return (
    <Card className={`shadow-md ${isReadable ? 'cursor-pointer' : ''}`} onClick={isReadable ? action : undefined }>
      <CardContent className='flex justify-between w-full items-center'>
        <div className='flex gap-1 items-center'>
          <div className='flex gap-1 items-center'>
            <ClipboardPlus className='w-4 h-4' />
            <p className='font-semibold'>{formatDateToDDMMYYYY(date)}</p>
          </div>
          <div>|</div>
          <p className='text-xxs bg-primary-30 max-w-[150px] truncate rounded-md px-2 py-1 md:max-w-[250px]'>
            {labName}
          </p>
          {!isReadable ? (<p className='text-xxs flex'>I tuoi esami sono stati caricati correttamente e sono ora in fase di elaborazione. I risultati saranno disponibili a breve nella tua area personale. <FaHourglassHalf /></p>) : null}
        </div>
        {isReadable && (
          <div className='flex gap-3 items-center'>
            <p className='text-xs'>{numberOfDocs} marker</p>
            <ChevronRight className='w-2 h-2 ' />
          </div>
        )}
      </CardContent>
    </Card>
  );
};
